import log from '../../../util/logger';
import { getValue } from '../../../util/object';

export function marketsIdServiceTransform(data, params) {
    const ret = [];
    const map = new Map();
    data.Records = data.Records || [];
    data.Records.forEach(d => {
        map.set(d.QueryKey, d);
    });
    const emptySymbols = [];

    params.symbol.split(',').forEach(symbol => {
        if (map.size > 0) {
            if (map.has(symbol)) {
                ret.push(getSecurityJSON(map.get(symbol)));
            } else {
                emptySymbols.push(symbol);
            }
        } else {
            emptySymbols.push(symbol);
            if (/^\d+\.\d+\.\S+$/.test(symbol)) {
                const rtInfo = symbol.split('.');
                ret.push(
                    getSecurityJSON({
                        ListingMarket: rtInfo[0],
                        SecurityType: rtInfo[1],
                        Symbol: rtInfo[2],
                        QueryKey: symbol
                    })
                );
            } else {
                ret.push(
                    getSecurityJSON({
                        QueryKey: symbol
                    })
                );
            }
        }
    });

    if (emptySymbols.length) {
        log.error(
            'morningstar.markets.marketdata.idService',
            'can not get data from remote',
            {
                symbols: emptySymbols
            }
        );
    }

    return ret;
}

export function marketsImportFileTransform(data) {
    return (data.data || []).map(d => {
        return getSecurityJSON(d);
    });
}

function getSecurityJSON(d) {
    return {
        mstarType: getValue(d, 'Type,type'),
        mstarSymbol: getValue(d, 'Ticker,msSymbol'),
        rtType: getValue(d, 'SecurityType,securityType'),
        rtExchangeId: getValue(d, 'ListingMarket,listingMarket'),
        rtMarketDataExchangeID: getValue(
            d,
            'MarketDataExchangeID,marketDataExchangeID'
        ),
        rtSymbol: getValue(d, 'Symbol,symbol'),
        clientSymbol: getValue(d, 'ClientTicker,clientTicker'),
        performanceId: getValue(d, 'PID,performanceId'),
        securityId: getValue(d, 'SID,secId'),
        companyId: getCompanyId(d),
        categoryId: getValue(d, 'OF012'),
        relativeRiskBenchmarkId: getValue(d, 'OS384'),
        name: getValue(d, 'OS01W,Name,companyName'),
        currency: getValue(d, 'Currency,currency'),
        queryKey: getValue(d, 'QueryKey,queryKey'),
        domicile: getValue(d, 'DomicileCountry,domicileCountry'),
        MICCode: getValue(d, 'AC031,micCode'),
        Exch: getValue(d, 'Exch,shortName'),
        CUSIP: getValue(d, 'CUSIP'),
        ISIN: getValue(d, 'ISIN'),
        region: getValue(d, 'Region,region'),
        strikePrice: getValue(d, 'StrikePrice')
    };
}

function getCompanyId(d) {
    let companyId = d.CFID;
    const mstarType = d.Type;
    switch (mstarType) {
        case 'FE':
        case 'FC':
        case 'FO':
            companyId = d.DAS02;
            break;
    }
    return companyId || '';
}
